export const CART_KEY = 'cart';
export const TTL_KEY = 'cartTtlMs';
export const DEFAULT_TTL_MS = 60 * 60 * 1000;

function readTtl() {
  const stored = Number(localStorage.getItem(TTL_KEY));
  if (!Number.isFinite(stored) || stored <= 0) {
    return DEFAULT_TTL_MS;
  }
  return stored;
}

let ttlMs = readTtl();

export function getTtlMs() {
  return ttlMs;
}

export function setTtlMinutes(minutes) {
  const parsed = Number(minutes);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return;
  }
  ttlMs = parsed * 60 * 1000;
  localStorage.setItem(TTL_KEY, String(ttlMs));
}

function readEntry() {
  const raw = localStorage.getItem(CART_KEY);
  if (raw === null) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.savedAt !== 'number' || !Array.isArray(parsed.form)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function load() {
  const entry = readEntry();
  if (entry === null) {
    localStorage.removeItem(CART_KEY);
    return [];
  }
  if (Date.now() - entry.savedAt > ttlMs) {
    localStorage.removeItem(CART_KEY);
    return [];
  }
  return entry.form;
}

export function pruneIfExpired() {
  const entry = readEntry();
  if (entry === null) {
    return false;
  }
  if (Date.now() - entry.savedAt > ttlMs) {
    localStorage.removeItem(CART_KEY);
    return true;
  }
  return false;
}

export function save(form) {
  const payload = { savedAt: Date.now(), form: Array.isArray(form) ? form : [] };
  localStorage.setItem(CART_KEY, JSON.stringify(payload));
}

export function clear() {
  localStorage.removeItem(CART_KEY);
}

export function registerExpiryRevalidation(store) {
  const revalidate = () => {
    if (document.visibilityState === 'hidden') return;
    store.dispatch('cart/revalidateExpiry');
  };
  document.addEventListener('visibilitychange', revalidate);
  window.addEventListener('pageshow', revalidate);
}

export function registerCrossTabSync(store) {
  window.addEventListener('storage', (event) => {
    if (event.key !== CART_KEY) return;
    if (event.newValue === null) {
      store.commit('cart/hydrate', []);
      return;
    }
    try {
      const parsed = JSON.parse(event.newValue);
      if (!parsed || typeof parsed.savedAt !== 'number' || !Array.isArray(parsed.form)) return;
      if (Date.now() - parsed.savedAt > ttlMs) return;
      store.commit('cart/hydrate', parsed.form);
    } catch {
      // ignore malformed payloads written by other code
    }
  });
}
